import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import logo from "../imgs/KLLogo2.png";

class Header2Comp extends Component {


    render() {
        return (
            <div>
                <Row>
                    <Col xs="3"></Col>
                    <Col xs="6"><center><br /><img src={logo} alt="logo" /></center></Col>
                    <Col xs="3"></Col>
                </Row>
                <br />
            </div>
        );
    }


}

export default Header2Comp;
